import {
  AUTH_HEADER_MENU_ACTIONS,
  buildAuthHeaderMenuItems,
  handleAuthHeaderMenuAction,
} from '@xstudios/xapp-auth/actions/headerMenuActions'
// import { useNotificationState } from '@xstudios/xapp-core/foundation'

export const APP_HEADER_MENU_ACTIONS = {
  // DISCONNECT_QUICKBOOKS: 'disconnect-quickbooks',
  // DISCONNECT_WORKSPACE: 'disconnect-workspace',
}

export function buildHeaderMenuItems() {
  return [
    // {
    //   action: APP_HEADER_MENU_ACTIONS.DISCONNECT_QUICKBOOKS,
    //   props: {
    //     prependIcon: 'mdi-book-open-variant',
    //   },
    //   title: 'Disconnect QuickBooks',
    //   value: APP_HEADER_MENU_ACTIONS.DISCONNECT_QUICKBOOKS,
    // },
    { type: 'divider' },
    ...buildAuthHeaderMenuItems(),
  ]
}

export async function handleHeaderMenuAction(action, context) {
  const handledByAuth = await handleAuthHeaderMenuAction(action, context)
  if (handledByAuth) {
    return
  }

  // const { notify } = useNotificationState()

  switch (action) {
    default: {
      return
    }
  }
}

export { AUTH_HEADER_MENU_ACTIONS }
